import React, { useState, useEffect } from "react";
import Dialog from "react-bootstrap-dialog";
import { Form, Row, Col, Table, Button } from 'react-bootstrap';
import FundTypeEnum from 'enums/FundTypeEnum';
import { toast } from 'react-toastify';
import Currency, {
  currencyReverse,
  CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText,
} from 'helpers/Currency';

const ActionsFormFundsExpire = props => {
  const [dialog, setDialog] = useState(null);
  const [totalExpense, setTotalExpense] = useState(0);
  const [valores, setValores] = useState([]);
  const [next,setNext] = useState({index:0,message_cancel:'Cancelar',message_yes:'Sim',message_no:'Não'});

  const updateValue = (id , value)=>{
    var retorno = valores.map(v=>{
      if(v.id==id){
        var value_aux = value.replace('R$ ','').replace('$ ','').replace('€ ','').replace('.','').replace(',','.');
        value_aux = parseFloat(value_aux!=''?value_aux:'0');
        v.value = value_aux;
      }
      return v;
    });
    setValores(retorno);
  };

  const updateTotalExpense = () => {
    let exp = parseFloat(parseFloat(props.calculateExpenseValue()).toFixed(2));
    let exp2 = 0;
    valores.map(v=>{
      exp2 += v.value;
    });
    exp2 = parseFloat(parseFloat(exp2).toFixed(2));
    setTotalExpense(exp-exp2);

    var t = document.getElementById('totalExpense');
    t.style.color = (exp-exp2)===0?'green':'red';
  };

  const getType = (fund_type_id,moeda)=>{
    var retorno = null;
    for(var enumMember in FundTypeEnum) {
      if(FundTypeEnum[enumMember] == fund_type_id)
        retorno = enumMember.toUpperCase() + (moeda?' '+moeda:'');
    }
    if(retorno == null){
      if(moeda != null){
        retorno = getType(fund_type_id-4,'Dólar');
        if(retorno == null)
        retorno = getType(fund_type_id-8,'Euro');
      }
    }
    return retorno;
  };

  const currencyTypes=(fund_type_id,value)=>{
    if(fund_type_id-8 > 0){
      return (
        <CurrencyEuroPlainText value={value}/>
      );
    } else if(fund_type_id-4 > 0){
      return (
        <CurrencyDollarPlainText value={value}/>
      );
    } else {
      return (
        <CurrencyPlainText value={value}/>
      );
    }
  }

  const submitFormExpire = expires => {
    let formData = props.buildFormStatus();
    formData.append("expires", expires);
    
    props.changeStatusAction(formData);
  };

  const hideModal = () => {
    dialog.hide();
    props.showFundsExpireModal(false);
  };

  const accept = () => {
    if(next.index == 0){
      if(valores.length == 1){
        valores[0].value = totalExpense;
        submitFormExpire(JSON.stringify(valores));
      } else {
        let next_aux = {
          message_yes:'Enviar',
          message_no:'Cancelar',
          index:1
        };
        setNext(next_aux);
      }
    }else if(next.index == 1){
      if(totalExpense===0){
        submitFormExpire(JSON.stringify(valores));
      }else {
        toast.error('Sobra do valor expirado tem que ser igual a 0', {
          autoClose: 5000,
        });
        var retorno = valores.map(v=>{
          v.value = 0;
          return v;
        });
        
        setValores(retorno);
        updateTotalExpense();
      }
    }
  };

  const refuse = () => {
    if(next.index == 1){
      let next_aux = {
        message_yes:'Sim',
        message_no:'Não',
        index:0
      };
      setNext(next_aux);
    } else if(next.index == 0){
      submitFormExpire(0);
    }
  };

  const getValueAnt = (id)=>{
    var v = 0;
    valores.map(a=>{
      if(a.id == id)
        v = a.value;
    });
    return v;
  }

  
  const getCurrency = (currency) => {
    if(currency.fund_type_id-8 > 0)
      return 'EUR'
    else if(currency.fund_type_id-4 > 0)
      return 'USD'
    else 
      return 'BRL';
  } 

  useEffect(()=>{
    let exp = props.calculateExpenseValue();
    setTotalExpense(parseFloat(parseFloat(exp).toFixed(2)));
    var valores = [];
    props.funds.map(fund =>{
      if(fund.value > 0)
        valores.push({id:fund.id,value:0});
    });
    setValores(valores);
  },[props,next]);

  useEffect(() => {
    let expenseValue = props
      .calculateExpenseValue()
      .toLocaleString("pt-BR", { style: "currency", currency: props.funds[0] ? getCurrency(props.funds[0]) : 'BRL' });
    let msg =
      "Ainda faltam " +
      expenseValue +
      " para comprovar. A verba restante será expirada?";
    
    msg = (
      <>
        {next.index === 1?(
        <>
        <Row>
          <Col>
          Informe o Valor Expirado:
          </Col>
        </Row>
        <Table bordered hover responsive>
          <thead>
            <tr>
              <th className="text-center align-middle">Tipo</th>
              <th className="text-center align-middle">Valor da Ação</th>
              <th className="text-center align-middle">Valor Expirado</th>
            </tr>
          </thead>
          <tbody>
            {props.funds.map(fund =>(
              fund.value > 0?(
              <tr>
                <td>
                  {getType(fund.fund_type_id)}
                </td>
                <td>
                  <Form.Group>
                    {currencyTypes(fund.fund_type_id,fund.value)}
                  </Form.Group>
                </td>
                <td>
                <Currency
                  value={getValueAnt(fund.id)!=0?getValueAnt(fund.id):''}
                  onChange={(e) =>{
                    updateValue(fund.id.toString(),e.target.value);
                    updateTotalExpense();
                  }
                }
                />
                </td>
              </tr>
              ):(<></>)
            ))}
            <tr>
              <td colSpan="2">Sobra do Valor Expirado</td>
              <td id="totalExpense" style={{color:totalExpense!=0?'red':'green'}}>
                {totalExpense.toLocaleString("pt-BR", { style: "currency", currency: props.funds[0] ? getCurrency(props.funds[0]) : 'BRL' })}
              </td>
            </tr>
          </tbody>
        </Table>
        </>
        ):
        (<>
        <Row>
          <Col>
          {msg}
          </Col>
        </Row>
        </>)}
      </>
    );

    const close =() =>{
      dialog.hide();
      props.showFundsExpireModal(false);
    }

    if (props.fundsExpireModal) {
      dialog.show({
        body: msg,
        actions: [
          Dialog.Action(next.message_no, () => refuse(), "btn-danger"),
          Dialog.Action(next.message_yes, () => accept(), "btn-success"),
          Dialog.Action(next.message_cancel, () => hideModal(), "btn-danger")
        ],
        bsSize: "small",
        onHide: () => {
          if(next.index===0){
            let next_aux = {
              message_no:'Não',
              message_yes:'Sim',
              message_cancel:'Cancelar',
              index:0
            };
            setNext(next_aux);
          }
          hideModal();
        }
      });
    }
  }, [props,totalExpense,next,valores]);

  return (
    <>
      <Dialog ref={component => {setDialog(component);}}/>
    </>
  );
};

export default ActionsFormFundsExpire;